import { getAccessToken } from "@mindlercare/auth";
import { apiUrls } from "@mindlercare/schema";
import axios, { AxiosResponse } from "axios";
import {
  countryIdFromMarket,
  getCountryCode,
} from "../../helpers/getCountryCode";
import { DEFAULT_LANG } from "../../helpers/language";
import { auth } from "../auth";

export const httpClient = axios.create();

httpClient.interceptors.request.use(async (prev) => {
  const config = prev;
  config.baseURL =
    apiUrls[import.meta.env.VITE_STAGE][
      getCountryCode() === "SE" ? "SE" : "XG"
    ].baseApiUrl;
  config.headers.set("countryId", countryIdFromMarket(getCountryCode()));

  config.headers.set("applanguage", DEFAULT_LANG);
  const accessToken =
    import.meta.env.NODE_ENV !== "test"
      ? await getAccessToken(auth)
      : "testtoken";

  // For this endpoint we don't want to include the accessToken,
  // because if an expired token is provided, we get 401
  // which blocks the refresh logic
  // Also refresh logic might still be broken for some users.
  // https://mindler.atlassian.net/browse/B2BB-644
  if (accessToken && config.url !== "application/configuration/web") {
    config.headers.set("Authorization", `JWT ${accessToken}`);
  }
  return config;
});

export const get = async <TResponse>(url: string) => {
  const axiosGet = await httpClient.get<TResponse>(url);
  return axiosGet.data;
};

export const put = async <TResponse, TPayload>(
  url: string,
  payload: TPayload,
) => {
  const axiosPut = await httpClient.put<
    TResponse,
    AxiosResponse<TResponse>,
    TPayload
  >(url, payload);
  return axiosPut.data;
};

export const post = async <TResponse, TPayload>(
  url: string,
  payload: TPayload,
) => {
  const axiosPost = await httpClient.post<
    TResponse,
    AxiosResponse<TResponse>,
    TPayload
  >(url, payload);
  return axiosPost.data;
};

export const del = async <TResponse, TPayload>(
  url: string,
  payload: TPayload,
) => {
  const axiosDelete = await httpClient.delete<
    TResponse,
    AxiosResponse<TResponse>,
    TPayload
  >(url, { data: payload });

  return axiosDelete.data;
};
